import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";
import {PublicApiAccessList} from "../models/publicApiAccessList";
import {PublicApiAccess} from "../models/publicApiAccess";

@Injectable({ providedIn: 'root' })
export class PublicApiAccessService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number) {

        return this.http.get<PublicApiAccessList>(`${environment.apiEndpoint}/v1/public-api-accesses?offset=`+offset+`&limit=`+limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<PublicApiAccess>(`${environment.apiEndpoint}/v1/public-api-accesses/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/public-api-accesses/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/public-api-accesses`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/public-api-accesses/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
